/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 01.07.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, FormGroup } from 'external/react-bootstrap';
import {
  ConfirmFormContainer,
  CustomModal,
  CustomModalBody,
  DraggableList,
  FormActions
} from 'plugin/liferay-widgets-react-web';

import MapConfigEditPluginForm from './MapConfigEditPluginForm';
import MapConfigPluginDragItem from './MapConfigPluginDragItem';

class MapConfigPlugins extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedPlugin: null,
      showEditPluginModal: false
    };

    this.DATA = {
      FORM_DELETE_CONFIRM: 'MapConfigPluginsDeleteConfirm'
    };
  }

  onEditPlugin(plugin, e) {
    e.stopPropagation();
    this.setState({
      selectedPlugin: plugin,
      showEditPluginModal: true,
      isNew: false
    });
  }

  onAddPlugin() {
    this.setState({
      selectedPlugin: null,
      showEditPluginModal: true,
      isNew: true
    });
  }

  handleSubmitEditPluginModal(formData) {
    let { plugins } = this.props;

    const { selectedPlugin } = this.state;

    const { path, config, valid } = formData;

    const plugin = {
      path,
      config,
      valid,
      key: selectedPlugin ? selectedPlugin.key : (plugins && plugins.length) || 0
    };

    let newPlugins = [ plugin ];
    if (plugins) {
      let replaced = false;
      newPlugins = plugins.map(p => {
        if (p.path === path) {
          replaced = true;
          return plugin;
        }
        return p;
      });
      if (!replaced) {
        newPlugins.push(plugin);
      }
    }
    this.props.onChange(newPlugins);

    this.setState({
      showEditPluginModal: false
    });
  }

  handleCancelEditPluginModal() {
    this.setState({
      showEditPluginModal: false
    });
  }

  onDeletePlugin(e, plugin) {
    e.stopPropagation();
    FormActions.startEditFormItem(this.DATA.FORM_DELETE_CONFIRM, plugin);
    this.setState({
      selectedPlugin: plugin,
    });
  }

  handleSubmitDeletePluginModal() {
    let { plugins } = this.props;
    FormActions.stopEditFormItem(this.DATA.FORM_DELETE_CONFIRM);

    plugins.splice(plugins.indexOf(this.state.selectedPlugin), 1);

    this.setState({
      selectedPlugin: null,
    });
  }

  render() {
    const {
      selectedPlugin,
      showEditPluginModal,
      isNew
    } = this.state;

    const { plugins, onChange } = this.props;

    return (
      <React.Fragment>

        <div className="button-box-v">
          <Button variant="primary" type="button" onClick={this.onAddPlugin.bind(this)}>
            Plugin hinzufügen
          </Button>

        </div>

        <FormGroup>
          <DraggableList
            DragItem={MapConfigPluginDragItem}
            list={plugins && plugins.length > 0 ? [ ...plugins ] : []}
            onEditElement={this.onEditPlugin.bind(this)}
            onDeleteElement={this.onDeletePlugin.bind(this)}
            changeOrder={onChange}
            keyProp="path"
          />

        </FormGroup>

        <CustomModal
          show={showEditPluginModal}
          onHide={this.handleCancelEditPluginModal.bind(this)}>
          <CustomModalBody>
            <MapConfigEditPluginForm
              formData={{ plugin: selectedPlugin, plugins, isNew }}
              onSubmit={this.handleSubmitEditPluginModal.bind(this)}
              onCancel={this.handleCancelEditPluginModal.bind(this)}
            />
          </CustomModalBody>

        </CustomModal>

        <ConfirmFormContainer
          editRequired={false}
          formId={this.DATA.FORM_DELETE_CONFIRM}
          formData={{ ...selectedPlugin }}
          submitButtonText="Löschen"
          onFormSubmit={this.handleSubmitDeletePluginModal.bind(this)}
          Content={({ formData }) => (
            'Wollen Sie das Plugin \'' + (formData.item || formData).path + '\' wirklich löschen?'
          )}
        />

      </React.Fragment>
    );
  }
}

MapConfigPlugins.propTypes = {
  plugins: PropTypes.array,
  onChange: PropTypes.func
};

export default MapConfigPlugins;



// WEBPACK FOOTER //
// ./js/components/MapConfigPlugins.jsx